<template>
    <div id="generator_content">
        <div class="generator_content">{{ title }}</div>
        <div class="generator_content1">
            <div v-for="(item, i) in aitemplate" :key="i">
                <generatorContentText
                    v-if="item.paramType == 'textarea' || item.paramType == 'text' || item.paramType == 'length'"
                    :templateItem="item" @getText="getText"></generatorContentText>
                <generatorContentStyle v-if="item.paramType == 'select'" :templateItem="item" @getStyle="getStyle">
                </generatorContentStyle>
            </div>

        </div>
        <div class="generator_content2">
            <div class="btn-primary" @click="submitResult">{{ btnText }} {{ vipType == 'common' ? freeNum ?
                `(免费次数${freeNum})` : '' : '' }}</div>
        </div>
    </div>
</template>
<script>

import generatorContentText from '../components/generator_contentText.vue' //文本框
import generatorContentStyle from '../components/generator_contentStyle.vue' //风格框
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
export default {
    components: {
        generatorContentText, generatorContentStyle
    },
    data() {
        return {
            // loginState: false, //登录状态
            freeNum: null, //免费字数
            title: "", //标题
            vipType: '', //会员类型
            aitemplate: [], //请求模板数据
            showItem: [], //展示数据
            requestItem: {}, //请求数据
            btnText: '提交',
            questionType: '',
        }
    },
    mounted() {
        EventBus.$on('getTemplate', (item) => {
            this.title = item.name
            this.btnText = '提交'
            this.questionType = item.questionType
            this.getTemplate(item.questionType)
            EventBus.$emit('clearHistroy')
        })
        //刷新次数
        EventBus.$on('refCount',()=>{
            this.getuserInfo()
        })
    },
    beforeDestroy() {
        EventBus.$off('getTemplate');
        EventBus.$off('refCount');
    },
    created() {
        this.getuserInfo()
    },
    methods: {
        getuserInfo() {
            api.getUserinfo().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.vipType = res.data.vipType
                    this.freeNum = res.data.wnum
                    this.loginState = true
                }
            })
        },
        getTemplate(questionType) {
            this.aitemplate = []
            this.showItem = []
            this.requestItem = {}
            api.getTemplate(questionType).then((res) => {
                // console.log(res.data)
                if (res.code == 200) {
                    this.aitemplate = res.data
                    this.aitemplate.map((item) => {
                        let show = {}
                        show.paramName = item.paramName
                        show.content = ''
                        show.paramType = item.paramType
                        show.maxLength = item.maxLength
                        show.placeholder = item.placeholder
                        this.showItem.push(show) //添加数组
                        this.requestItem[item.paramKey] = '' //请求数据赋值Key
                    })
                }
            })

        },
        //获取文本
        getText(item, text) {
            this.addShow(text, item.paramName)
            this.addRequest(text, item.paramKey)
        },
        //风格
        getStyle(item, style) {
            this.addShow(style, item.paramName)
            this.addRequest(style, item.paramKey)
        },
        //添加展示数据
        addShow(text, paramName) {
            const targetItem = this.showItem.find(item => item.paramName === paramName);
            if (targetItem) {
                targetItem.content = text;
            }
        },
        //添加请求数据
        addRequest(text, paramKey) {
            for (const key in this.requestItem) {
                if (key === paramKey) {
                    this.requestItem[key] = text;
                }
            }
        },
        //提交
        submitResult() {
            if (!this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            let btnVa = true
            for (let i in this.showItem) {
                let item = this.showItem[i]
                if (item.content === '' && !item.paramName.includes('非必填')) {
                    this.$message({
                        message: `请输入${item.paramName}`,
                        type: 'warning'
                    });
                    btnVa = false
                    break
                }
                if (item.paramType === 'length' && item.placeholder) {
                    if (Number(item.content) > Number(item.placeholder)) {
                        this.$message({
                            message: `输入数字长度超出范围！`,
                            type: 'warning'
                        });
                        btnVa = false
                        break
                    }
                }
            }
            if(!btnVa) return
            
            let resultItem = {
                requestItem: this.requestItem,
                showItem: this.showItem,
                type: this.questionType
            }
            sessionStorage.setItem('resultItem', JSON.stringify(resultItem));
            EventBus.$emit('getResult')
            this.btnText = '重新提交'
        }
    }
}
</script>

<style>
#generator_content {
    width: 375px;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 5px 5px 0 0;
}

.generator_content {
    width: 100%;
    height: 67px;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    display: flex;
    align-items: center;
    padding-left: 20px;
    border-bottom: 1px solid #DDDDDD;
}

.generator_content1 {
    width: 100%;
    height: calc(100% - 138px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px;
}

.generator_content2 {
    height: 69px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #DDDDDD;
}

.generator_content2_1 {
    min-width: 120px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    background: linear-gradient(87deg, #FF9900 0%, #FF6603 100%);
    border-radius: 38px;
    cursor: pointer;
    padding: 0 15px;
}
</style>